import { atom } from 'jotai'

import { tenantStore } from '../tenant-store'

type QueryParamHistory = {
  path: string
  params: Record<string, unknown>
}

export const queryParamHistoryAtom = atom<QueryParamHistory | null>(null)

tenantStore.set(queryParamHistoryAtom, null)

queryParamHistoryAtom.debugLabel = 'queryParamHistoryAtom'
